export default __webpack_public_path__ + "static/media/Bevacimab.9cf1eabc.png";